"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogoUrl = exports.getUploadImageUrl = exports.getImagesList = void 0;
var imagesList = {
    imagesUrls: [
        '../../icons/emailTemplates/images/emailTemplates-1.png',
        '../../icons/emailTemplates/images/emailTemplates-2.png',
        '../../icons/emailTemplates/images/emailTemplates-3.png',
        '../../icons/emailTemplates/images/emailTemplates-4.png',
        '../../icons/emailTemplates/images/emailTemplates-5.png',
        '../../icons/emailTemplates/images/emailTemplates-6.png',
        '../../icons/emailTemplates/images/emailTemplates-7.png',
        '../../icons/emailTemplates/images/emailTemplates-8.png',
        '../../icons/emailTemplates/images/emailTemplates-9.png',
        '../../icons/emailTemplates/images/emailTemplates-10.png',
        '../../icons/emailTemplates/images/emailTemplates-11.png',
        '../../icons/emailTemplates/images/emailTemplates-12.png',
    ],
};
var logoUrl = {
    imagesUrls: [
        '../../icons/emailTemplates/logo/emailTemplates-logo.png',
        '../../icons/emailTemplates/logo/emailTemplates-logo2.png',
    ],
};
var uploadImageResponse = {
    uploadUrl: 'www.s3.com/images/file-name.svg',
    contentType: 'svg',
    imageUrl: 'www.images.codebashing.com/file-name.svg',
};
var getImagesList = function () { return imagesList; };
exports.getImagesList = getImagesList;
var getUploadImageUrl = function () { return uploadImageResponse; };
exports.getUploadImageUrl = getUploadImageUrl;
var getLogoUrl = function () { return logoUrl; };
exports.getLogoUrl = getLogoUrl;
